/* eslint-disable default-case */
/* eslint-disable no-extra-parens */
import { GET_SOLAR_DATA_BY_LAT_LNG, GetSolarDataType } from '../actions/solarActions';
import type { ILocationSolarDateTime } from '../../components/forecasts/common/types';

interface SolarState {
    solarData: ILocationSolarDateTime[];
    isLoading: boolean;
    lastError: Record<string, unknown> | undefined;
}

const getInitialAlmanacSolarDataFromServer = (initialServerSolarData: ILocationSolarDateTime[]) => {
    if (Array.isArray(initialServerSolarData) && initialServerSolarData?.length > 0) {
        // eslint-disable-next-line dot-notation
        (window as any)._AppData['shouldUseServerAlmanacSolarData'] = true;

        return initialServerSolarData;
    }
    return [];
};

const initialServerSolarData = getInitialAlmanacSolarDataFromServer((window as any)._AppData?.Almanac?.[0]?.Solar);

const initialState: SolarState = {
    solarData: initialServerSolarData,
    isLoading: false,
    lastError: undefined
};

export function solar(state: SolarState = initialState, action: GetSolarDataType)
{
    switch (action.type)
    {
        case GET_SOLAR_DATA_BY_LAT_LNG.pending:
        {
            return {
                ...state,
                solarData: [],
                lastError: undefined,
                isLoading: true
            };
        }
        case GET_SOLAR_DATA_BY_LAT_LNG.fulfilled:
        {
            return {
                ...state,
                solarData: action.payload?.Solar,
                isLoading: false
            };
        }

        case GET_SOLAR_DATA_BY_LAT_LNG.rejected:
        {
            return {
                ...state,
                lastError: action.payload,
                isLoading: false
            };
        }
    }

    return state;
}